import { Box, Skeleton, Text } from "@chakra-ui/react";
import {
  EhrName,
  EhrProvider,
  PatientOverview,
  PatientOverviewV2,
  SharedStateProvider,
} from "@metriport/shared-internal";
import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import { ossBaseUrlPracticeFusion } from "../../../api/api";
import {
  acceptTermsOfService,
  getTermsOfServiceAccepted,
  // writeResourceToChart,
  // TODO: ENG-1929
  // getResourceDiffJob,
  // startResourceDiffJob,
} from "../../../api/ehr/practicefusion";
import { useAppContext } from "../../contexts/app/index";
import useMetriportToast from "../../shared/toast";
import { TermsOfServiceModal } from "./TermsOfServiceModal";

const termsOfServiceQueryKey = ["practicefusion", "terms-of-service"];
const TERMS_OF_SERVICE_ERROR_MESSAGE =
  "Please re-open the app. If the problem persists, reach out to support@metriport.com";

export default function PatientPage() {
  const { state } = useAppContext();
  const queryClient = useQueryClient();
  const toast = useMetriportToast();

  const termsOfServiceQuery = useQuery({
    queryKey: termsOfServiceQueryKey,
    queryFn: getTermsOfServiceAccepted,
    enabled: state.isLoaded,
  });

  const acceptTermsOfServiceMutation = useMutation({
    mutationFn: acceptTermsOfService,
    onSuccess: () => {
      queryClient.setQueryData(termsOfServiceQueryKey, {
        isTermsOfServiceAccepted: true,
      });
    },
    onError: () => {
      toast.error({
        title: `Failed to accept Terms of Service. ${TERMS_OF_SERVICE_ERROR_MESSAGE}`,
      });
    },
  });

  if (!state.isLoaded) {
    return null;
  }

  const { ehrPatientId } = state;
  if (!ehrPatientId) {
    return (
      <Box>
        <Text>No Patient</Text>
      </Box>
    );
  }

  if (termsOfServiceQuery.isLoading) {
    return <Skeleton height="100vh" width="100vw" />;
  }

  if (termsOfServiceQuery.isError) {
    return (
      <Box p={4}>
        <Text>Something went wrong. {TERMS_OF_SERVICE_ERROR_MESSAGE}</Text>
      </Box>
    );
  }

  if (!termsOfServiceQuery.data?.isTermsOfServiceAccepted) {
    return (
      <TermsOfServiceModal
        isOpen={true}
        isAccepting={acceptTermsOfServiceMutation.isPending}
        onAccept={() => acceptTermsOfServiceMutation.mutate()}
      />
    );
  }

  const ehrDetails = {
    ehrPatientId,
    name: EhrName.PracticeFusion,
    // write: writeResourceToChart,
    // TODO: ENG-1929
    // diff: {
    //   startResourceDiffJob,
    //   getResourceDiffJob,
    // },
  };

  return (
    <Box>
      <SharedStateProvider
        authToken={state.authToken}
        baseUrl={ossBaseUrlPracticeFusion}
        ehrDetails={ehrDetails}
        featureFlags={state.featureFlags}
      >
        {state.featureFlags.shouldShowLegacyDashV1 ? (
          <PatientOverview patientId={ehrPatientId} />
        ) : (
          // after v1 code is removed, remove ehrDetails from SharedStateProvider ^!
          <EhrProvider patientId={ehrPatientId} ehrDetails={ehrDetails}>
            <PatientOverviewV2 patientId={ehrPatientId} />
          </EhrProvider>
        )}
      </SharedStateProvider>
    </Box>
  );
}
